import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'DeliveryItem',
    column_type: 'id',
    label_key_path: 'deliveryItem.id',
  },
  created_at: {
    model_name: 'DeliveryItem',
    column_type: 'datetime',
    label_key_path: 'deliveryItem.createdAt',
  },
  updated_at: {
    model_name: 'DeliveryItem',
    column_type: 'datetime',
    label_key_path: 'deliveryItem.updatedAt',
  },
  delivery: {
    model_name: 'DeliveryItem',
    column_type: 'belongs_to',
    label_key_path: 'deliveryItem.delivery',
    extra: {
      association_name: 'delivery',
      model_name: 'Delivery',
      foreign_key: 'delivery_id',
      display_column: 'id',
    },
  },
  delivery_id: {
    model_name: 'DeliveryItem',
    column_type: 'belongs_to',
    label_key_path: 'deliveryItem.delivery',
    extra: {
      association_name: 'delivery',
      model_name: 'Delivery',
      foreign_key: 'delivery_id',
      display_column: 'id',
    },
  },
  line_item: {
    model_name: 'DeliveryItem',
    column_type: 'belongs_to',
    label_key_path: 'deliveryItem.lineItem',
    extra: {
      association_name: 'line_item',
      model_name: 'LineItem',
      foreign_key: 'line_item_id',
      display_column: 'id',
    },
  },
  line_item_id: {
    model_name: 'DeliveryItem',
    column_type: 'belongs_to',
    label_key_path: 'deliveryItem.lineItem',
    extra: {
      association_name: 'line_item',
      model_name: 'LineItem',
      foreign_key: 'line_item_id',
      display_column: 'id',
    },
  },
  quantity: {
    model_name: 'DeliveryItem',
    column_type: 'integer',
    label_key_path: 'deliveryItem.quantity',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
